import { render, staticRenderFns } from "./Who.vue?vue&type=template&id=c4a738c0"
var script = {}
import style0 from "./Who.vue?vue&type=style&index=0&id=c4a738c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports